import React, { useEffect, useState } from "react";
import Head from "next/head";
import gql from "graphql-tag";
import { Header } from "./Header/web";
import './styles.less';
import { useFilters } from "shared-components/Components/Filters/Filters.hook";
import { useGoogleTagManager } from "shared-components/GlobalHooks/web/GoogleTagManager.hook";
import { useQuery } from "@apollo/client";
import { ListingStructDataJson } from "shared-components/ViewFragments/SearchPage/ListingStructDataJson";
import { SearchResultsPagination } from "shared-components/ViewFragments/SearchResults/Content/SearchResultsCards/SearchResultsPagination/web";
import { Listings } from "./Listings";
import { Button } from "shared-components/Components/Buttons/web";
import dynamic from "next/dynamic"
import { ButtonMapToggle } from "shared-components/ViewFragments/SearchResults/Content/MapButton/web";
import { Order } from "shared-components/Components/Filters/Order/web";
import { SearchResultDisplay } from "shared-components/ViewFragments/SearchResults/Content/SearchResultsCards/SearchResultsPagination/ResultDisplay/web";
import { useWindowSize } from "shared-components/GlobalHooks/useWindowSize";
import { BreadCrumbs } from "shared-components/Components/SEO/BreadCrumbs/web";
import { H1 } from "shared-components/Components/SEO/H1/web";
import cookie from "js-cookie";
import { useUser } from "shared-components/Components/User/User.hook";
import { Footer } from "shared-components/ViewFragments/Footer/web";
import { PicHomeFooter } from "shared-components/ViewFragments/Footer/PicHomeFooter/web";
import { FiltersIcon } from "shared-components/Components/CustomIcons/FiltersIcon/web";
import TopBarFilters from "shared-components/ViewFragments/SearchResults/Sider/TopBarFilters/web"

//@ts-ignore
const SearchResultsMap = dynamic(() => import(/* webpackChunkName: "SearchResultsMap" */ "shared-components/ViewFragments/SearchResults/Content/SearchResultsMap/web"), { ssr: false, loading: () => <></> })
const SiderBar = dynamic(() => import(/* webpackChunkName: "SiderBar" */ "./SiderBar"), { ssr: false, loading: () => <div className="search-filters"></div> })

const IcBuscaPorTi = dynamic(() => import("shared-components/Components/PopUps/IcBuscaPorTi/web"), { ssr: false, loading: () => <div className="search-filters"></div> })


const RESULTS_PER_PAGE = 21;
const QUERY_SEARCH_RESULTS_CARDS = gql`
    query ResultsGird_v2($rows: Int!, $params: SearchParamsInput!, $page: Int, $source: Int) {
        searchFast(params: $params, first: $rows, page: $page, source: $source) 
    }
`;

export const SearchPageLayout_v3 = () => {
    const { filters } = useFilters()
    const GTM = useGoogleTagManager()
    const { data, loading, error } = useQuery(QUERY_SEARCH_RESULTS_CARDS, {
        variables: {
            rows: RESULTS_PER_PAGE,
            params: filters,
            page: filters?.page,
            source: 0
        },
        skip: filters?.map_bounds || filters?.map_polygon,
        fetchPolicy: "cache-first"
    })

    const [map, setMap] = useState<boolean>(false)
    const screen = useWindowSize()
    const [sider, setSider] = useState(true)
    const { user } = useUser()

    useEffect(() => {
        if (data && data.length > 0) {
            GTM.Event({
                name: "searchresults",
                data: {
                    listing_id: data.map(p => p.id),
                    listing_totalvalue: data.map(p => p.price),
                    listing_pagetype: "searchresults",
                },
            });
        }
    }, [data]);

    let noIndex = false
    let noFollow = false
    if (
        data?.searchFast?.data && data?.searchFast?.data?.length == 0 ||
        filters?.neighborhood_id && filters?.neighborhood_id?.length > 2 ||
        filters?.property_type_id && filters?.property_type_id?.length > 2 ||
        filters?.owner_id ||
        filters?.bedrooms && filters?.bedrooms.length > 1 ||
        filters?.order && [4, 5].includes(filters?.order)
    ) {
        console.warn('Page with: noindex, nofollow')
        noIndex = true
        noFollow = true
    } else if (data?.searchFast?.data && data?.searchFast?.data?.length <= 10) {
        console.warn('Page with: nofollow')
        noIndex = false
        noFollow = true
    } else {
        noIndex = false
        noFollow = false
    }

    // cosas IC Busca Por vos
    const [modal, setModal] = useState(false)

    const idealFilters = [
        "operation_type_id",
        "property_type_id",
        "maxPrice",
        "bedrooms"
    ]

    const handleClose = () => {
        cookie.set('modalBuscaPorTi', 'Si', { expires: 7 })
    }

    useEffect(() => {
        const cookieModal = cookie.get("modalBuscaPorTi")
        if (!modal && typeof cookieModal === "undefined") {
            const filtersKeys = Object.keys(filters);
            const hasIdealFilters = idealFilters.every(elem => filtersKeys.includes(elem));
            if (filters.page >= 2 && hasIdealFilters) {
                let showModal = true;
                if (user.data.me && user.data.me.searchAlerts) {
                    (user.data.me.searchAlerts ?? []).map((search) => {
                        const searchStringify = JSON.stringify(search.filters);
                        const filtersAsArray = Object.entries(filters).filter((filter) => filter[0] !== "page" && filter[0] !== "order" && filter[0] !== "map_bounds");
                        const finalFiltersObject = Object.fromEntries(filtersAsArray);
                        const filtersStringify = JSON.stringify(finalFiltersObject);
                        if (showModal !== true) {
                            if (searchStringify === filtersStringify) showModal = false
                            else showModal = true
                        }
                    })
                }
                setModal(showModal);
            }
        }
    }, [filters, user])
    // ENDS cosas IC Busca Por vos

    const affixedMobileButtons = (
        <div className="search-results-affix-bar">
            <Button className="open_filter_btn" type="secondary" onClick={() => { setSider(!sider) }} >
                <FiltersIcon /> Filtrar
            </Button>
            <ButtonMapToggle map={map} setMap={setMap} />
            <Order />
        </div>
    )

    const topContent = (
        <div className="topContent-wrap" >
            <div className="search-result-text-info">
                <H1 />
                {!screen.xs && <BreadCrumbs />}
                {!map && data?.searchFast?.paginatorInfo && <SearchResultDisplay loading={loading} error={error} paginatorInfo={data?.searchFast?.paginatorInfo} />}
            </div>
            {screen.lg && affixedMobileButtons}
        </div>
    );


    return <>

        <Header showSearchBar isSticky={false} />

        {(noIndex || noFollow) && <>
            <Head>
                <meta name="robots" content={!noIndex ? 'nofollow' : 'noindex, nofollow'} />
            </Head>
        </>}
        {data?.searchFast?.data && data?.searchFast?.data?.length == 0 &&
            <ListingStructDataJson listings={data?.searchFast?.data} />
        }

        {screen.lg && <TopBarFilters />}
        {!screen.lg && affixedMobileButtons}

        <div className="search-page-container">
            {(!sider) && <SiderBar sider={sider} setSider={setSider} map={map} />}
            <div className="search-results-content" style={
                map ? {
                    position: 'sticky',
                    top: '96px'
                } : {}
            } >

                {topContent}
                {map
                    ? <SearchResultsMap />
                    : <>
                        <Listings data={data} loading={loading} error={error} />
                        <SearchResultsPagination error={error} loading={loading} paginatorInfo={data?.searchFast?.paginatorInfo} />
                    </>
                }

            </div>

        </div>

        {/* @TODO - sacar antd y refactor estos 3 componentes
        */}
        {modal && <IcBuscaPorTi onClose={handleClose} showButtons />}
        {!map && <Footer />}
        {!map && <PicHomeFooter />}

    </>
}

